import * as React from 'react';
import {  SecureRoute } from '@okta/okta-react';

export const OktaSecuredRoute = ({ component: Component, layout: Layout, path: Path, ...rest }) => {
    /* Below code commented WI 26952 Start */
    //var isLoginPath = Path === "/";
    //if (window.location.search != "" && window.location.search != null)
    //    sessionStorage.setItem("QueryTag", window.location.search);
    //if (isNullOrUndefined(sessionStorage.getItem('UserInfo')) && !isLoginPath && Path != "/forgotpassword") {
    //    var redirectPath = "/";
    //    if (sessionStorage.getItem('okta-token-storage') != null) {

    //        if (sessionStorage.getItem("UrlPath") != null) {
    //            redirectPath = redirectPath + sessionStorage.getItem("UrlPath");
    //        }
    //        //this.props.history.push("/" + redirectPath);

    //    }
    //    return <Redirect to={{
    //        pathname: redirectPath,
    //    }} />;
    //}
    //else if (!isNullOrUndefined(sessionStorage.getItem('UserInfo')) && Path === "/") {
    //    //return <Redirect to="/" />;
    //    if (isNullOrUndefined(sessionStorage.getItem('UserInfo')) && !isLoginPath && Path != "/forgotpassword") {
    //        var redirectPath = "/";
    //        if (sessionStorage.getItem('okta-token-storage') != null) {

    //            if (sessionStorage.getItem("UrlPath") != null) {
    //                redirectPath = redirectPath + sessionStorage.getItem("UrlPath");
    //            }
    //            //this.props.history.push("/" + redirectPath);

    //        }
    //        return <Redirect to={{
    //            pathname: redirectPath,
    //        }} />;
    //    }
    //}
    /* Below code commented WI 26952 End */

    return <SecureRoute {...rest} render={props => (
        <Layout>
            <Component {...props} />
        </Layout>
    )} />;
}